export const BOAT_TYPE_LIST = [
  { name: 'All', value: 'All' },
  { name: 'Boat', value: 'BOAT' },
  { name: 'Yacht', value: 'YACHT' },
  { name: 'Sailboat', value: 'SAILBOAT' },
  { name: 'Pontoon', value: 'PONTOON' },
  { name: 'Catamaran', value: 'CATAMARAN' },
  { name: 'Jonboat', value: 'JON_BOAT' },
  { name: 'PWC', value: 'PWC' },
  { name: 'Inflatable', value: 'INFLATABLE' },
  { name: 'Kayak / Canoe', value: 'CANOE_KAYAK' },
];

export const STEP_ID = {
  BOAT_TYPE: 'boat_type',
  ENGINE_TYPE: 'engine_type',
  BOAT_SPECIFICATIONS: 'boat_specifications',
  ADD_COMPONENTS: 'add_components',
  CUBIC_CAPACITY: 'cubic_capacity',
  WEIGHT_CAPACITY: 'weight_capacity',
  POWER_CAPACITY: 'power_capacity',
  FLOATATION_CAPACITY: 'floatation_capacity',
  FINAL_REVIEW: 'final_review',
  LOAD_DOCUMENTS: 'load_documents',
};

export const STEP_NAME = {
  BOAT_TYPE: 'Boat Type',
  ENGINE_TYPE: 'Engine Type',
  BOAT_SPECIFICATIONS: 'Boat Specifications',
  ADD_COMPONENTS: 'Add Components',
  CUBIC_CAPACITY: 'Cubic Capacity',
  HULL_CALCULATIONS: 'Hull Calculations',
  WEIGHT_CAPACITY: 'Weight/ HP Capacity',
  POWER_CAPACITY: 'Max Power Capacity',
  FLOATATION_CAPACITY: 'Flotation Capacity',
  FINAL_REVIEW: 'Final Review',
  LOAD_DOCUMENTS: 'Load Documents',
};

export const AREA_TYPES = {
  AA_EIGHTH_LENGTH_FORWARD: 'AA_EIGHTH_LENGTH_FORWARD',
  A_QTR_LENGTH_FORWARD: 'A_QTR_LENGTH_FORWARD',
  B_AMIDSHIPS: 'B_AMIDSHIPS',
  C_QTR_LENGTH_AFT: 'C_QTR_LENGTH_AFT',
  D_TRANSOM: 'D_TRANSOM',
};

export const BOAT = 'BOAT';
export const YACHT = 'YACHT';
export const SAILBOAT = 'SAILBOAT';
export const PONTOON = 'PONTOON';
export const CATAMARAN = 'CATAMARAN';
export const JON_BOAT = 'JON_BOAT';
export const PWC = 'PWC';
export const INFLATABLE = 'INFLATABLE';
export const CANOE_KAYAK = 'CANOE_KAYAK';

export const OUTBOARD = 'OUTBOARD';
export const INBOARD = 'INBOARD';
export const NON_POWERED = 'NON_POWERED';

export const INFLATABLE_ENGINE_TYPES = [INBOARD, OUTBOARD, NON_POWERED];

export const SINGLE = 'SINGLE';
export const TWIN = 'TWIN';

export const MODIFIED_V = 'MODIFIED_V';
export const SEMI_V = 'SEMI_V';
export const TRI_HULL = 'TRI_HULL';
export const V = 'V';
export const ROUND_BILGE = 'ROUND_BILGE';
export const FLAT = 'FLAT';

export const DIESEL_POWER_TYPE = ['Standard', 'Optional'];

export const ENGINE_SUB_TYPES_NAMES = [
  { name: 'Up to 6 HP.', value: 'SUB_TYPE_1' },
  { name: 'Over 6 HP. and up to 20 HP.', value: 'SUB_TYPE_2' },
  { name: 'Over 20 HP. and up to 100 HP.', value: 'SUB_TYPE_3' },
  { name: 'Over 100 HP.', value: 'SUB_TYPE_4' },
];

export const BOAT_STEPS = {
  BOAT: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.CUBIC_CAPACITY, name: STEP_NAME.CUBIC_CAPACITY },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.FLOATATION_CAPACITY, name: STEP_NAME.FLOATATION_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  YACHT: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  SAILBOAT: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.CUBIC_CAPACITY, name: STEP_NAME.CUBIC_CAPACITY },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.FLOATATION_CAPACITY, name: STEP_NAME.FLOATATION_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  PONTOON: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.CUBIC_CAPACITY, name: STEP_NAME.HULL_CALCULATIONS },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  CATAMARAN: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.CUBIC_CAPACITY, name: STEP_NAME.CUBIC_CAPACITY },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.FLOATATION_CAPACITY, name: STEP_NAME.FLOATATION_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  JON_BOAT: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.CUBIC_CAPACITY, name: STEP_NAME.CUBIC_CAPACITY },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.FLOATATION_CAPACITY, name: STEP_NAME.FLOATATION_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  PWC: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  INFLATABLE: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
  CANOE_KAYAK: [
    { id: STEP_ID.BOAT_TYPE, name: STEP_NAME.BOAT_TYPE },
    { id: STEP_ID.ENGINE_TYPE, name: STEP_NAME.ENGINE_TYPE },
    { id: STEP_ID.BOAT_SPECIFICATIONS, name: STEP_NAME.BOAT_SPECIFICATIONS },
    { id: STEP_ID.ADD_COMPONENTS, name: STEP_NAME.ADD_COMPONENTS },
    { id: STEP_ID.WEIGHT_CAPACITY, name: STEP_NAME.WEIGHT_CAPACITY },
    { id: STEP_ID.POWER_CAPACITY, name: STEP_NAME.POWER_CAPACITY },
    { id: STEP_ID.FLOATATION_CAPACITY, name: STEP_NAME.FLOATATION_CAPACITY },
    { id: STEP_ID.LOAD_DOCUMENTS, name: STEP_NAME.LOAD_DOCUMENTS },
    { id: STEP_ID.FINAL_REVIEW, name: STEP_NAME.FINAL_REVIEW },
  ],
};

export const getBoatSteps = (boatType = BOAT, engineType) =>
  BOAT_STEPS[boatType || BOAT].filter(step => engineType === OUTBOARD || step.id !== STEP_ID.FLOATATION_CAPACITY);

export const BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS = [
  STEP_ID.BOAT_TYPE,
  STEP_ID.ENGINE_TYPE,
  STEP_ID.BOAT_SPECIFICATIONS,
  STEP_ID.ADD_COMPONENTS,
  STEP_ID.CUBIC_CAPACITY,
  STEP_ID.WEIGHT_CAPACITY,
  STEP_ID.POWER_CAPACITY,
  STEP_ID.FLOATATION_CAPACITY,
  STEP_ID.FINAL_REVIEW,
];

export const BOAT_STATUSES = [
  {
    id: 0,
    value: 'All',
    name: 'All statuses',
    active: true,
  },
  {
    id: 1,
    value: 'DRAFT',
    name: 'Draft',
    active: true,
  },
  {
    id: 2,
    value: 'APPROVED',
    name: 'Approved',
    active: true,
  },
  {
    id: 3,
    value: 'DEACTIVATED',
    name: 'Deactivated',
    active: true,
  },
  {
    id: 4,
    value: 'INCOMPLETE',
    name: 'Incomplete',
    active: true,
  },
];



// WEBPACK FOOTER //
// ./src/app/constants/boatApplication.js